// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const { HireInformation } = require('components/hire/hireInformation/hireInformation');
const HiringProductInformation = require('components/hiringProductInformation/hiringProductInformation');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const ContactCenterValidationCards = require('components/hire/contactCenterValidationCards/contactCenterValidationCards');

// @ constants
const { FIRST_STEP } = require('constants/index');
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const { VIA_T_CARD_PRODUCT_ALIAS, VIA_T_CARD_PRODUCT_ALIAS_CC, PRODUCT_HIRING_COMPONENT_ID } = require('constants/hiringProductInformation');
const { GC, CREDIT_CARD_REVOLVING_PROCESS } = require('constants/flagBasedFeatures');

class hireCardViaTStep1 extends React.Component {

    componentDidMount() {
        const {
            flagBasedFeatures,
            requestPDFMerge,
            setTermsAndCondsText,
        } = this.props;

        if (!__CONTACT_CENTER__) {
            const pdfurls = getCardsPreContractPdfData()['via-T'].preContractPdfLink;
            const product = {
                type: '532',
                subtype: '001',
                standard: '0000001'
            };
            const showIneAndRevolving = flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
            if (!showIneAndRevolving) {
                requestPDFMerge(pdfurls, [product]);
            }
        } else if (!!setTermsAndCondsText) {
            setTermsAndCondsText('hireCardViaT-step3CheckboxText');
        }
    }

    buildLegalConfirmationSection() {
        const { showIneAndRevolving } = this.props;
        if (!__CONTACT_CENTER__ || showIneAndRevolving) return null;

        const {
            contractName,
            handleAgreementCheckboxChange,
            immHireCardViaT,
            sendMailParams,
        } = this.props;

        const immStep = immHireCardViaT.getIn(['steps', FIRST_STEP]);
        const agreementLabel = <FormattedText value="hireCardViaT-step3CheckboxText" />; // Re-uses step 3 labels because they have to be the same
        const agreementErrorMsg = formatText('hireCardViaT-step3CheckboxErrorMsg'); // Re-uses step 3 labels because they have to be the same

        return (
            <ContactCenterValidationCards
                agreementErrorMsg={agreementErrorMsg}
                agreementLabel={agreementLabel}
                contractName={contractName}
                handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                immStep={immStep}
                sendMailParams={sendMailParams}
            />
        );
    }

    render() {
        const { immHireInformation, gestorCrossEnabled, flagBasedFeatures } = this.props;
        const legalConfirmationSection = this.buildLegalConfirmationSection();
        let productInformationComponent;
        if(gestorCrossEnabled && flagBasedFeatures && flagBasedFeatures.get(GC)) {
            productInformationComponent = (
                <React.Fragment>
                    <HiringProductInformation
                        productAlias={VIA_T_CARD_PRODUCT_ALIAS}
                        productComponentId={PRODUCT_HIRING_COMPONENT_ID}
                    />
                    <ContactCenterRender>
                        {legalConfirmationSection}
                    </ContactCenterRender>
                </React.Fragment>
            )
        } else {
            productInformationComponent = (
                <article className="hire-card-via-t__step-one">
                    <FormattedText
                        className="hire-card-via-t__step-title"
                        value="hireCardViaT-step1Title"
                    />
                    <HireInformation
                        hireCmsKey={!__CONTACT_CENTER__ ? this.props.hireCmsKey : VIA_T_CARD_PRODUCT_ALIAS_CC}
                        immHireInformation={immHireInformation}
                    />
                    <ContactCenterRender>
                        {legalConfirmationSection}
                    </ContactCenterRender>
                </article>
            )
        }
        return (
            <div>
                {productInformationComponent}
            </div>
        );
    }
}

hireCardViaTStep1.propTypes = {
    contractName: PropTypes.string,
    flagBasedFeatures: PropTypes.object.isRequired,
    gestorCrossEnabled: PropTypes.bool,
    handleAgreementCheckboxChange: PropTypes.func,
    hireCmsKey: PropTypes.string.isRequired,
    immHireCardViaT: PropTypes.object,
    immHireInformation: PropTypes.object.isRequired,
    requestPDFMerge: PropTypes.func.isRequired,
    sendMailParams: PropTypes.object,
    setTermsAndCondsText: PropTypes.func,
    showIneAndRevolving: PropTypes.bool,
};

module.exports = hireCardViaTStep1;
